"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalTwitterIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const ExternalTwitterIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.089 8.626c.01.158.01.316.01.475 0 4.86-3.698 10.463-10.462 10.463v-.003A10.41 10.41 0 0 1 4 17.913a7.384 7.384 0 0 0 5.442-1.524 3.682 3.682 0 0 1-3.435-2.554c.551.106 1.119.084 1.66-.063a3.678 3.678 0 0 1-2.95-3.605v-.046a3.655 3.655 0 0 0 1.67.46 3.682 3.682 0 0 1-1.139-4.91 10.437 10.437 0 0 0 7.579 3.842 3.68 3.68 0 0 1 6.266-3.354 7.38 7.38 0 0 0 2.336-.893A3.691 3.691 0 0 1 19.812 7.3a7.313 7.313 0 0 0 2.112-.58 7.47 7.47 0 0 1-1.835 1.906Z"
}));
exports.ExternalTwitterIcon = ExternalTwitterIcon;